import { BlockTextModule } from './../../components/block-text-img/block-text-img.module';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { HomeComponent } from './home.component';
import { HomeRoutingModule } from './home-routing.module';
import { SlideBannerModule } from 'src/app/components/slide-banner/slide-banner.module';
import { SwiperModule } from 'swiper/angular';
import { CardModule } from 'src/app/components/card-component/card-component.module';


@NgModule({
    declarations: [
        HomeComponent
    ],
    imports: [
        CommonModule,
        LazyLoadImageModule,
        HomeRoutingModule, 
        SlideBannerModule,
        SwiperModule, 
        BlockTextModule,
        CardModule
    ]
})
export class HomeModule { }


